<html>

    <body class="dx-viewport">
      
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->  
        <dx-box
            direction="row"
            width="100%"
            [height]="formheight"
        >
             <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 
            <dxi-item
                [ratio]="1.5"
                class="rectangle"
            >
                <!----------------------------------------------------------------------------------------------->
                <dx-select-box 
                    [dataSource]="this.whoseguest" 
                    valueExpr="id" 
                    displayExpr="fullname"
                    (onItemClick)="buildstats($event)"
                >
                </dx-select-box>
                <!----------------------------------------------------------------------------------------------->
                <br>
                <br>
                <!----------------------------------------------------------------------------------------------->
                <dx-chart
                    #barfinancechart
                    id="barfinancechart"
                            
                    [dataSource]="barchart"

                    [rotated]="false"

                    [animation]="false"

                    palette="Dark Moon"
                    
                    (onPointClick)="onPointClick($event)"
                    (onPointHoverChanged)="onPointHoverChanged($event)"
                >
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-size
                       
                    >
                    </dxo-size>

                    <!----------------------------------------------------------------------------------------------->
                    <dxo-title
                        [text]="barcharttitle"

                        verticalAlignment="top"
                        horizontalAlignment="left"
                        
                    >
                        <dxo-font
                            color="white"
                            [size]="20"
                        >
                        </dxo-font>
                        
                    </dxo-title>
                    <!----------------------------------------------------------------------------------------------->
                    <dxi-value-axis
                        name="cost"
                        position="left"
                        [showZero]="true"
                        [tickInterval]="500"
                       
                        [visualRange]="{ startValue: setminYValue, endValue: setmaxYvalue}"
                        [visible]="visibleYaxis"
                    >
                        <!----------------------------------------------------------------------------------------------->
                        <dxi-constant-line
                            [value]="setmaxYvalue"
                            color="#465672"
                            dashStyle="solid"
                            [extendAxis]="true"
                            
                            [width]="constantlinewidth"
                        >

                            <dxo-label  
                                [visible]="false"
                            >
                            </dxo-label>

                        </dxi-constant-line>

                        <dxi-constant-line
                            [value]="setminYValue"
                            color="#465672"
                            dashStyle="solid"
                            [extendAxis]="true"
                            
                            [width]="constantlinewidth"
                        >

                            <dxo-label  
                                [visible]="false"
                            >
                            </dxo-label>

                        </dxi-constant-line>
                        <!----------------------------------------------------------------------------------------------->
                        <dxi-constant-line
                            [value]="totalfullBudget"
                            color="#fc3535"
                            dashStyle="solid"
                            [extendAxis]="true"
                            
                            [width]="constantlinewidth"
                        >
                        <dxo-label  

                            [text]="linebudgettotaltext"
                           
                            [font]="{color: '#F76E6E', size: 12, weight: 900}"
                           
                            verticalAlignment="top"
                            horizontalAlignment="right"

                            [visible]="true"
                       
                        >
                        </dxo-label>

                    </dxi-constant-line>
                    <!----------------------------------------------------------------------------------------------->
                        <dxi-constant-line
                            [value]="totalbudget"
                            color="#fc3535"
                            dashStyle="solid"
                            [extendAxis]="true"
                            
                            [width]="constantlinewidth"
                        >
                            <dxo-label  

                                [text]="linebudgettext"
                               
                                [font]="{color: '#F76E6E', size: 12, weight: 900}"
                               
                                verticalAlignment="top"
                                horizontalAlignment="right"

                                [visible]="true"
                           
                            >
                            </dxo-label>

                        </dxi-constant-line>
                        <!----------------------------------------------------------------------------------------------->
                        <dxi-constant-line
                            [value]="totalactualtask"
                            color="rgb(0, 153, 0)"
                            dashStyle="solid"
                            [extendAxis]="true"
                            
                            [width]="constantlinewidth"
                        >
                            <dxo-label 

                                [text]="lineactualtext"

                                [font]="{color: '#ffffff', size: 10, weight: 900}"
                                
                                verticalAlignment="bottom"
                                horizontalAlignment="center"

                                [visible]="true"
                           
                            >
                            </dxo-label>

                        </dxi-constant-line>
                        <!----------------------------------------------------------------------------------------------->
                        <dxi-constant-line
                            [value]="totalactualalloctaskbar"
                            color="rgb(0, 153, 0)"
                            dashStyle="solid"
                            [extendAxis]="true"
                            
                            [width]="constantlinewidth"
                        >
                            <dxo-label 

                                [text]="linealloctext"

                                [font]="{color: '#ffffff', size: 10, weight: 900}"
                                
                                verticalAlignment="bottom"
                                horizontalAlignment="left"

                                [visible]="true"
                           
                            >
                            </dxo-label>

                        </dxi-constant-line>
                        <!----------------------------------------------------------------------------------------------->
                        <dxi-constant-line
                            value=0
                            color="rgb(0,0,0)"
                            dashStyle="solid"
                            [extendAxis]="true"
                            
                            [width]="constantlinewidth"
                        >
                            <dxo-label 

                                color="#fc3535"
                                verticalAlignment="bottom"
                                [visible]="false"
                           
                            >
                            </dxo-label>

                        </dxi-constant-line>
                        <!----------------------------------------------------------------------------------------------->
                        <dxo-grid [visible]="false"></dxo-grid>

                    </dxi-value-axis>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-common-series-settings
                                
                        type="bar"

                        argumentField="costtype"
                        valueField="amount"
                    
                        hoverMode="allArgumentPoints"
                        selectionMode="allArgumentPoints"

                        [ignoreEmptyPoints]="true"

                        [minBarSize]="10"
                    >
                        <dxo-point>
                            <dxo-hover-style
                    
                            >
                            </dxo-hover-style>
                        </dxo-point>

                    </dxo-common-series-settings>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-series-template nameField="costtype" [customizeSeries]="customizeSeries"></dxo-series-template>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-tooltip
                        [enabled]="charttooltip"
                        [customizeTooltip]="customizeTooltip"
                    >
                    </dxo-tooltip>
                    <!----------------------------------------------------------------------------------------------->
                    <dxo-legend 
                        [visible]="false"
                        position="inside"
                        horizontalAlignment="right"
                        verticalAlignment="top"
                        orientation="vertical"

                        [customizeItems]="orderLegendItems"
                
                    >
                    </dxo-legend>
                    <!----------------------------------------------------------------------------------------------->
                  
                </dx-chart>
                <!----------------------------------------------------------------------------------------------->
                
            </dxi-item>
             <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 
             <dxi-item
                [ratio]="1.5"
            >

                <dx-box
                    direction="col"
                    width="100%"
                    height="100%"
                >
                    
                    <dxi-item
                        [ratio]="1"
                    >
                        <!----------------------------------------------------------------------------------------------->
                        <dx-box
                            direction="row"
                        >
                            <dxi-item
                                [ratio]="1"
                                class="rectangle"
                            >  
                                Budget Spend: {{totalbudget}}    
                            </dxi-item>

                            <dxi-item
                                [ratio]="1"
                                class="rectangle"
                            >  
                                Actual Spend: {{totalactualtask}}   
                            </dxi-item>

                            <dxi-item
                                [ratio]="1"
                                class="rectangle"
                            >  
                                {{savingcost}} {{totalsavings}}   
                            </dxi-item>

                        </dx-box>
                        <!----------------------------------------------------------------------------------------------->
                    </dxi-item>
                    <!----------------------------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="10"
                    >
                        <!----------------------------------------------------------------------------------------------->
                        <dx-tree-list
                            #financetree
                            id="financetree"
                            [dataSource]="barcharttree"
                        
                            keyExpr="spendid"
                            parentIdExpr="spendparentid"

                            [columnAutoWidth]="false"
                            [wordWrapEnabled]="true"
                            [showBorders]="true"

                            [showRowLines]="true"
                            [showBorders]="true"

                            [repaintChangesOnly]="true"

                            (onRowClick)="treerowclick($event)"
                            (onCellHoverChanged)="treerowclick($event)"

                            (onCellPrepared)="onCellPrepared($event)"

                            width="98%"
                            height="100%"
                        >
                            <!----------------------------------------------------------------------------------------------->
                            <dxo-selection 
                                mode="single">
                            </dxo-selection>

                            <dxo-scrolling 
                                mode="standard"
                            >
                            </dxo-scrolling>

                            <dxo-paging 
                                [enabled]="true" 
                                [pageSize]="10"> 
                            </dxo-paging>

                            <dxo-pager
                                [showPageSizeSelector]="true"
                                [allowedPageSizes]="[1, 5, 10]"
                                [showInfo]="true"
                            >
                            </dxo-pager>

                            <dxo-editing
                                mode="row"
                                [allowUpdating]="false"
                                [allowDeleting]="false"
                                [allowAdding]="false"
                            >
                            </dxo-editing>
                            <!----------------------------------------------------------------------------------------------->
                            <dxi-column 
                                dataField="spendid" 
                                caption="spendid"
                                width="1%"
                                [visible]="true"

                                cellTemplate="cellTemplate"
                            >
                        
                            </dxi-column>

                            <div *dxTemplate="let cell of 'cellTemplate'">
                                {{cell.text}}
                                <div>
                                    <img [src]="" [id]="'taskid' + cell.text" />
                                </div>    
                            
                            </div>
                            <!----------------------------------------------------------------------------------------------->
                            <dxi-column 
                                dataField="providername" 
                                caption="Provider"
                                width="30%"
                            >
                            
                            </dxi-column>
                            <!----------------------------------------------------------------------------------------------->
                            <dxi-column 
                                dataField="eventorganisername" 
                                caption="Organiser"
                                width="30%">
                            
                            </dxi-column>
                            <!----------------------------------------------------------------------------------------------->
                            <dxi-column 
                                dataField="percshare" 
                                caption="Allocation %"
                                width="20%">
                            
                            </dxi-column>
                            <!----------------------------------------------------------------------------------------------->
                            <dxi-column 
                                dataField="budgetamount" 
                                caption="Budget [B]"
                                [visible]="false"
                                width="20%">
                            
                            </dxi-column>
                            <!----------------------------------------------------------------------------------------------->
                            <dxi-column 
                                dataField="actualamount" 
                                caption="Actual Spend"
                                width="20%"
                            >
                        
                            </dxi-column>
                            <!----------------------------------------------------------------------------------------------->
                            <dxi-column 
                                dataField="actualallocated" 
                                caption="Allocated % Spend"
                                width="20%">
                            
                            </dxi-column>
                            <!----------------------------------------------------------------------------------------------->
                           
                        <!----------------------------------------------------------------------------------------------->
                        </dx-tree-list>
                   
                    </dxi-item>
                    <!----------------------------------------------------------------------------------------------->
                    <dxi-item
                        [ratio]="0.05"
                    >
                        
                    </dxi-item>
                    <!----------------------------------------------------------------------------------------------->
                </dx-box>
            <!----------------------------------------------------------------------------------------------->    
            </dxi-item>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 
        </dx-box>
         <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
         <dx-popup
            #popcollaborator
            id="popcollaborator"
            [width]="300"
            [height]="150"
            [showTitle]="true"
            title="Collaborator Details"
            [dragEnabled]="true"
            [hideOnOutsideClick]="true"
            [showCloseButton]="true"

            [shading]="false"

            [(visible)]="showprovider"
         >

            <dxo-position
                my="left top"
                at="left top"
                [of]="positionOf"
       
            >
                <dxo-offset
                    [x]="-320" 
                    [y]="-100"
                >
                </dxo-offset>

            </dxo-position>

            <dx-box
                direction="row"
                height="100%"
            >

                <dxi-item
                    [ratio]="3"
                >  
                    <dx-box
                        direction="col"
                        height="100%"
                    >
                        <dxi-item
                            [ratio]="1"
                            class="rectangle"
                        >   
                        
                            <span>{{contactperson}}</span>
                        </dxi-item>

                        <dxi-item
                            [ratio]="0.04"
                        >
                        </dxi-item>

                        <dxi-item
                            [ratio]="1"
                            class="rectangle"
                        >   
                            <span>{{mobile}}</span>
                        </dxi-item>

                        <dxi-item
                            [ratio]="0.04"
                        >
                        </dxi-item>

                        <dxi-item
                            [ratio]="1"
                            class="rectangle"
                        >   
                            <span>{{phone}}</span>  
                        </dxi-item>

                    </dx-box>

                </dxi-item>

                <dxi-item
                    [ratio]="2"
                    class="rectangle"
                >   
                    <span>{{notes}}</span>
                </dxi-item>

            </dx-box>

        </dx-popup>
       <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    </body>

</html>